import { useFleet } from './useFleet';
import { Event } from '../interfaces';

export const useRouteMappingEnabledForEvent = (event?: Event): boolean => {
  const fleet = useFleet();

  const eventAuthority = event?.authority_id;
  if (!eventAuthority) {
    return false;
  }

  const authority = fleet?.authorities?.find((a) => a.authority_id === eventAuthority);
  const streetIdSource = authority?.config?.evidence_packager_config?.street_id_source;

  return streetIdSource === 'route_mapping';
};
